import { useState } from "react";
import { deepAssign } from "utils/utils";

/**
 * @typedef {Object} useFormUndoReturn
 * @property {Object} memorizedFormValue - The memorized form value
 * @property {(Object) => void} rememberForm - invoke to memorize the form value, provide the to-be memorized values as an argumnent to override the current form value
 * @property {(Object) => void} rememberPartialForm - invoke to memorize the form value, provide the to-be memorized values as an argumnent to override the current form value
 * @property {() => void} undoForm - invoke to revert the form to the memorized value
 * @property {(formKey: string, valueAccessor: (value: any) => any) => void} undoPartialForm - invoke to revert the form to the memorized value
 * @property {() => void} clearFormMemory - invoke to clear the memorized form value
 */

/**
 * @param {Object} props
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 */
const useFormUndo = ({ formProps }) => {
  const [orgFormValue, setOrgFormValue] = useState(null);
  const { getValues, setValue, reset } = formProps;

  const rememberForm = (values) => {
    const formValues = structuredClone(values || getValues());
    setOrgFormValue(formValues)
  };
  const rememberPartialForm = (values) => {
    setOrgFormValue((prev) => {
      const temp = structuredClone(prev)
      deepAssign(temp, values)
      return temp;
    });
  };
  const undoForm = () => {
    reset(orgFormValue);
  };
  const undoPartialForm = (formKey, valueAccessor) => {
    setValue(formKey, valueAccessor(orgFormValue));
  };
  const clearFormMemory = () => setOrgFormValue(null);

  return { memorizedFormValue: orgFormValue, rememberForm, rememberPartialForm, undoForm, undoPartialForm, clearFormMemory };
}

export default useFormUndo;